import { getCompanyFeatureFlags } from 'adminPanel/api/companies';
import { FeatureFlag } from 'adminPanel/types';
import { useEffect, useState } from 'react';

export const useCompanyFeatureFlags = (companyId: number) => {
    const [featureFlags, setFeatureFlags] = useState<FeatureFlag[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getCompanyFeatureFlags(companyId)
            .then(setFeatureFlags)
            .finally(() => {
                setIsLoading(false);
            });
    }, [companyId]);

    const refetch = () => {
        getCompanyFeatureFlags(companyId)
            .then(setFeatureFlags)
            .finally(() => {
                setIsLoading(false);
            });
    };

    return { featureFlags, isLoading, refetch };
};
